import {
  type Motif,
  Black,
  defaultMotif,
  FontFamily,
  Gray,
  Green,
  m,
  mergeMotifs,
  MotifComponent,
  MotifScheme,
  Plain,
} from '@snapchat/snap-design-system-marketing';

/** Generated by figmaTokensImport on 2023-10-30T22:41:44.824Z. */
export const customGreenMotif: Motif = mergeMotifs(defaultMotif, {
  name: 'Green',
  fontFamily: FontFamily.GRAPHIK,
  [MotifScheme.DEFAULT]: {
    name: 'Imported Deafult',
    legacyName: 'Yellow',
    [MotifComponent.ROOT]: {
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--background-color': Green.V100,
      '--foreground-color': '#042500',
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': '#042500',
      '--button-primary-hover-bg-color': '#042500',
      '--button-primary-border-color': '#042500',
      '--button-primary-hover-border-color': '#042500',
      '--button-primary-fg-color': '#f0fff0',
      '--button-secondary-bg-color': '#f0fff0',
      '--button-secondary-hover-bg-color': '#f0fff0',
      '--button-secondary-border-color': '#f0fff0',
      '--button-secondary-hover-border-color': '#f0fff0',
      '--button-secondary-fg-color': '#042500',
      '--button-flat-fg-color': `${m('--foreground-color')}`,
      '--button-border-radius': `${m('--border-radius-m')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-xl)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {},
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': '#042500',
      '--block-title-color': '#042500',
      '--block-subtitle-color': '#042500',
    },
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': '#f0fff0',
      '--quote-fg-color': '#042500',
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--background-color')}`,
      '--footer-bar-bg-color': `${m('--background-color')}`,
    },
    [MotifComponent.FORM]: {
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {},
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': '#f0fff0',
      '--dropdown-item-fg-color': Black.V50,
      '--dropdown-item-fg-active-color': '#042500',
      '--dropdown-item-bg-hover-color': '#c6dfc6',
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--background-color')}`,
      '--banner-fg-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-color': Black.V100,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': Green.V100,
      '--mosaic-title-color': '#f0fff0',
    },
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': '#c6dfc6',
    },
    [MotifComponent.PAGINATION]: {
      '--pagination-text-active-color': '#042500',
    },
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-background-color': 'rgba(0,0,0,0.7)',
      '--modal-close-background-color': '#042500',
      '--modal-close-foreground-color': '#f0fff0',
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-bg-color': Plain.BLACK,
      '--icon-button-hover-bg-color': Black.V100,
      '--icon-button-disabled-bg-color': 'rgba(0,0,0,0)',
    },
  },
  [MotifScheme.SECONDARY]: {
    name: 'Imported secondary',
    legacyName: 'Black',
    [MotifComponent.ROOT]: {
      '--box-shadow-s': '0px 4px 8px 0 rgba(0, 0, 0, 0.12)',
      '--box-shadow-m': '0px 8px 16px 0 rgba(0, 0, 0, 0.12)',
      '--border-radius-xs': '1px',
      '--border-radius-s': '4px',
      '--border-radius-m': '8px',
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--spacing-xxxs': '2px',
      '--spacing-xxs': '4px',
      '--spacing-xs': '8px',
      '--spacing-s': '12px',
      '--spacing-m': '16px',
      '--spacing-l': '24px',
      '--spacing-xl': '32px',
      '--spacing-xxl': '40px',
      '--spacing-xxxxl': '64px',
      '--background-color': '#042500',
      '--foreground-color': '#f0fff0',
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': Green.V100,
      '--button-primary-hover-bg-color': Green.V100,
      '--button-primary-border-color': Green.V100,
      '--button-primary-hover-border-color': Green.V100,
      '--button-primary-fg-color': '#042500',
      '--button-secondary-bg-color': '#f0fff0',
      '--button-secondary-hover-bg-color': '#f0fff0',
      '--button-secondary-border-color': '#f0fff0',
      '--button-secondary-hover-border-color': '#f0fff0',
      '--button-secondary-fg-color': '#042500',
      '--button-flat-fg-color': '#f0fff0',
      '--button-border-radius': `${m('--border-radius-m')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-xl)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-fg-color': Gray.V150,
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': '#f0fff0',
      '--block-title-color': '#f0fff0',
      '--block-subtitle-color': '#f0fff0',
    },
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': '#f0fff0',
      '--quote-fg-color': '#042500',
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--background-color')}`,
      '--footer-bar-bg-color': `${m('--background-color')}`,
      '--footer-divider-border-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.FORM]: {
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': Gray.V300,
      '--footnote-bg-color': Plain.WHITE,
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': Black.V100,
      '--dropdown-item-fg-color': Gray.V250,
      '--dropdown-item-fg-active-color': '#f0fff0',
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--background-color')}`,
      '--banner-fg-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-color': Gray.V200,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': Green.V100,
      '--mosaic-title-color': '#f0fff0',
    },
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': '#c6dfc6',
      '--search-no-results-fg-color': Black.V150,
    },
    [MotifComponent.PAGINATION]: {
      '--pagination-text-active-color': '#f0fff0',
      '--pagination-text-color': Gray.V300,
      '--pagination-text-hover-color': Gray.V250,
    },
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-background-color': 'rgba(0,0,0,0.7)',
      '--modal-close-background-color': '#042500',
      '--modal-close-foreground-color': '#f0fff0',
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-hover-bg-color': Gray.V150,
      '--icon-button-disabled-bg-color': Black.V50,
      '--icon-button-border-color': Plain.WHITE,
      '--icon-button-fg-color': Plain.BLACK,
      '--icon-button-disabled-fg-color': Gray.V300,
    },
  },
  [MotifScheme.TERTIARY]: {
    name: 'Imported tertiary',
    legacyName: 'White',
    [MotifComponent.ROOT]: {
      '--box-shadow-s': '0px 4px 8px 0 rgba(0, 0, 0, 0.12)',
      '--box-shadow-m': '0px 8px 16px 0 rgba(0, 0, 0, 0.12)',
      '--border-radius-xs': '1px',
      '--border-radius-s': '4px',
      '--border-radius-m': '8px',
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--spacing-xxxs': '2px',
      '--spacing-xxs': '4px',
      '--spacing-xs': '8px',
      '--spacing-s': '12px',
      '--spacing-m': '16px',
      '--spacing-l': '24px',
      '--spacing-xl': '32px',
      '--spacing-xxl': '40px',
      '--spacing-xxxxl': '64px',
      '--background-color': '#f0fff0',
      '--foreground-color': '#042500',
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': Green.V100,
      '--button-primary-hover-bg-color': Green.V100,
      '--button-primary-border-color': Green.V100,
      '--button-primary-hover-border-color': Green.V100,
      '--button-primary-fg-color': '#042500',
      '--button-secondary-bg-color': '#042500',
      '--button-secondary-hover-bg-color': '#042500',
      '--button-secondary-border-color': '#042500',
      '--button-secondary-hover-border-color': '#042500',
      '--button-secondary-fg-color': '#f0fff0',
      '--button-flat-fg-color': '#042500',
      '--button-border-radius': `${m('--border-radius-m')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-xl)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-nav-screen-bg-color': '#f0fff0',
      '--global-header-fg-color': Black.V150,
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': '#042500',
      '--block-title-color': '#042500',
      '--block-subtitle-color': '#042500',
    },
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': '#f0fff0',
      '--quote-fg-color': '#042500',
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--background-color')}`,
      '--footer-bar-bg-color': '#c6dfc6',
    },
    [MotifComponent.FORM]: {
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': Gray.V300,
      '--footnote-bg-color': Plain.WHITE,
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': '#f0fff0',
      '--dropdown-item-fg-color': Black.V50,
      '--dropdown-item-fg-active-color': '#042500',
      '--dropdown-item-bg-hover-color': '#c6dfc6',
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--background-color')}`,
      '--banner-fg-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-color': Black.V100,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': Green.V100,
      '--mosaic-title-color': '#f0fff0',
    },
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': '#c6dfc6',
      '--search-no-results-fg-color': Black.V150,
    },
    [MotifComponent.PAGINATION]: {
      '--pagination-text-active-color': '#042500',
    },
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-background-color': 'rgba(0,0,0,0.7)',
      '--modal-close-background-color': '#042500',
      '--modal-close-foreground-color': '#f0fff0',
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-bg-color': Plain.BLACK,
      '--icon-button-hover-bg-color': Black.V100,
      '--icon-button-disabled-bg-color': 'rgba(0,0,0,0)',
    },
  },
  [MotifScheme.QUATERNARY]: {
    name: 'Imported quaternary',
    legacyName: 'Gray',
    [MotifComponent.ROOT]: {
      '--box-shadow-s': '0px 4px 8px 0 rgba(0, 0, 0, 0.12)',
      '--box-shadow-m': '0px 8px 16px 0 rgba(0, 0, 0, 0.12)',
      '--border-radius-xs': '1px',
      '--border-radius-s': '4px',
      '--border-radius-m': '8px',
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--spacing-xxxs': '2px',
      '--spacing-xxs': '4px',
      '--spacing-xs': '8px',
      '--spacing-s': '12px',
      '--spacing-m': '16px',
      '--spacing-l': '24px',
      '--spacing-xl': '32px',
      '--spacing-xxl': '40px',
      '--spacing-xxxxl': '64px',
      '--background-color': '#c6dfc6',
      '--foreground-color': '#042500',
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': Green.V100,
      '--button-primary-hover-bg-color': Green.V100,
      '--button-primary-border-color': Green.V100,
      '--button-primary-hover-border-color': Green.V100,
      '--button-primary-fg-color': '#042500',
      '--button-secondary-bg-color': '#f0fff0',
      '--button-secondary-hover-bg-color': '#f0fff0',
      '--button-secondary-border-color': '#f0fff0',
      '--button-secondary-hover-border-color': '#f0fff0',
      '--button-secondary-fg-color': '#042500',
      '--button-flat-fg-color': '#042500',
      '--button-border-radius': `${m('--border-radius-m')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-xl)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-nav-screen-bg-color': '#f0fff0',
      '--global-header-fg-color': Black.V150,
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': '#042500',
      '--block-title-color': '#042500',
      '--block-subtitle-color': '#042500',
    },
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': '#f0fff0',
      '--quote-fg-color': '#042500',
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--background-color')}`,
      '--footer-bar-bg-color': `${m('--background-color')}`,
    },
    [MotifComponent.FORM]: {
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': Gray.V300,
      '--footnote-bg-color': Plain.WHITE,
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': '#f0fff0',
      '--dropdown-item-fg-color': Black.V50,
      '--dropdown-item-fg-active-color': '#042500',
      '--dropdown-item-bg-hover-color': '#c6dfc6',
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--background-color')}`,
      '--banner-fg-color': `${m('--foreground-color')}`,
    },
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-color': Black.V100,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': Green.V100,
      '--mosaic-title-color': '#f0fff0',
    },
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': '#c6dfc6',
      '--search-no-results-fg-color': Black.V150,
    },
    [MotifComponent.PAGINATION]: {
      '--pagination-text-active-color': '#042500',
    },
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-background-color': 'rgba(0,0,0,0.7)',
      '--modal-close-background-color': '#042500',
      '--modal-close-foreground-color': '#f0fff0',
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-bg-color': Plain.BLACK,
      '--icon-button-hover-bg-color': Black.V100,
      '--icon-button-disabled-bg-color': 'rgba(0,0,0,0)',
    },
  },
});
